import sendContactForm from "./sendContactForm";
export const sendContactFormService = sendContactForm;